/**
 * Formats a CUSIP to a standard format:
 * 1. 9 digits long
 * 2. Uppercase
 */
export function formatCusip(cusip: string): string {
    cusip = cusip.trim().toUpperCase();
    if (cusip.length === 8) cusip += getCusipWithChecksum(cusip);
    return cusip;
}

/**
 * Given an 8-digit CUSIP, returns the 9-digit CUSIP. This is possible because
 * the last digit of a CUSIP is a checksum.
 */
export function getCusipWithChecksum(cusip8: string): string {
    if (cusip8.length !== 8) {
        throw new Error("CUSIP must be 8 characters long (excluding checksum).");
    }

    const charToValue = (char: string): number => {
        if (/[0-9]/.test(char)) return parseInt(char, 10);
        if (/[A-Z]/.test(char)) return char.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
        if (char === '*') return 36;
        if (char === '@') return 37;
        if (char === '#') return 38;
        throw new Error(`Invalid CUSIP character: ${char}`);
    };

    const digits = cusip8.split('').map(charToValue);

    const transformed = digits.map((num, idx) => {
    const product = idx % 2 === 0 ? num * 1 : num * 2;
        return product > 9 ? Math.floor(product / 10) + (product % 10) : product;
    });

    const sum = transformed.reduce((acc, val) => acc + val, 0);
    const checksum = (10 - (sum % 10)) % 10;

    return checksum.toString();
}
